import {
  ActionButtonContainer,
  ActionButton,
} from "components/AgGrid/ActionButton";

import React from "react";

import { faClone } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface SideLoadedBusinessActionsRendererProps {
  context: {
    handleSelectAndCompare: (id: string) => void;
  };
  data: {
    id: string;
  };
}

export function SideLoadedBusinessActionsRenderer({
  context,
  data,
}: SideLoadedBusinessActionsRendererProps) {
  const { handleSelectAndCompare } = context;
  const { id } = data;

  const handleClick = () => {
    handleSelectAndCompare(id);
  };

  return (
    <ActionButtonContainer>
      <ActionButton onClick={handleClick} data-tour="selectAndCompare">
        <FontAwesomeIcon icon={faClone} />
        &nbsp;Use
      </ActionButton>
    </ActionButtonContainer>
  );
}
